// Task #2477 / Task #2484 — Single source of truth for the "paid this month"
// reporting bucket used by the operations task board summary.
//
// Payment reporting must bucket a task by *when it was actually paid*, not by
// `updatedAt` (which any later edit bumps, mis-bucketing the task into the
// current month). `updateTask` stamps a real `paidAt` on the non-paid → paid
// edge; this helper prefers it and only falls back to `updatedAt` for legacy
// paid tasks recorded before `paidAt` existed.

export interface PaidTaskFields {
  status: string;
  paidAt?: Date | string | null;
  updatedAt?: Date | string | null;
}

export function isTaskPaidInMonth(task: PaidTaskFields, ref: Date = new Date()): boolean {
  if (task.status !== "paid") return false;
  const paidSource = task.paidAt ?? task.updatedAt;
  if (!paidSource) return false;
  const paidTs = new Date(paidSource);
  if (Number.isNaN(paidTs.getTime())) return false;
  return (
    paidTs.getMonth() === ref.getMonth() &&
    paidTs.getFullYear() === ref.getFullYear()
  );
}
